<template>
  <div>
    <div v-if="isDraft" class="alert alert-success mb-5 mt-0 py-4" role="alert">
      <p class="mb-0">{{ $t('feeds.feed_draft_found') }}</p>
    </div>
    <div class="dashboard-content">
      <contact-modal></contact-modal>
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <div v-if="!isTemplatesLoading" class="d-flex feed-main-settings">
          <div class="main-settings-column1">
            <strong>{{ $t('global.file_name') }}</strong>
            <validation-provider class="mb-4" mode="lazy" :rules="{ required: true }" v-slot="{ errors }">
              <input v-model="feed.name" class="form-control w-100 mt-3" name="feedName" type="text">
              <span class="validation-error-required pl-2" v-if="errors[0] !== undefined">{{ $t('validations.required') }}</span>
            </validation-provider>
          </div>
          <div class="main-settings-column2">
            <strong>{{ $t('feeds.platform') }}</strong>
            <div class="d-flex align-items-center">
              <multiselect
                @select="onFeedTypeSelect"
                class="mt-3 mr-4"
                label="label"
                v-model="selectedFeedType"
                :allow-empty="false"
                :deselect-label="''"
                :options="feedTypes"
                :placeholder="$t('global.select_or_type')"
                :searchable="true"
                :select-label="''"
                :selected-label="''">
                <template slot="singleLabel" slot-scope="props">
                  <img :src="props.option.imageUrl" class="mr-4" height="25" width="25" />
                  <span class="option__title">{{ props.option.label }}</span>
                </template>
                <template slot="option" slot-scope="props">
                  <div>
                    <img :src="props.option.imageUrl" class="mr-4" height="25" width="25" />
                    <span class="option__title">{{ props.option.label }}</span>
                  </div>
                </template>
                <span slot="noResult">{{ $t('global.multiselect_search_not_found') }}</span>
              </multiselect>
              <img class="tooltip-icon icon-small mt-3 mx-4" id="tooltip-feed-type" v-bind:src="'/app/images/icons/info.svg'" />
              <b-popover target="tooltip-feed-type" variant="warning" triggers="hover" placement="bottomleft">
                <div v-html="$t('tooltips.feed_type')"></div>
              </b-popover>
              <div class="mt-2">
                <p class="mb-0">{{$t('global.no_format')}}</p>
                <a href="#" @click="$bvModal.show('contactModal')"><u>{{$t('global.contact')}}</u></a>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <router-link :to="{ name: 'feeds', params: { id: $route.params.projectId }}">
            <button class="btn btn-large btn-gray-dark">
              <arrow-left-circle-icon></arrow-left-circle-icon>
              <span>{{ $t('global.back') }}</span>
            </button>
          </router-link>
          <router-link :to="{ name: 'feed.create.field-mapping', params: { id: $route.params.projectId, feed: feed }}" v-bind:class="{ 'disabled-router-link': !isFeedTypeSelected || invalid }">
            <button class="btn btn-large btn-orange-dark" :disabled="!isFeedTypeSelected || invalid">
              <arrow-right-circle-icon></arrow-right-circle-icon>
              <span>{{$t('global.next')}}</span>
            </button>
          </router-link>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import feeds from '@/mixins/feeds'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import Multiselect from 'vue-multiselect'
import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from 'vue-feather-icons'
import ContactModal from './ContactModal'

extend('required', {
  ...required
})

export default {
  name: 'MainSettings',

  data () {
    return {
      isDraft: localStorage.feed,
      selectedFeedType: null
    }
  },

  props: {
    feed: { required: true, type: Object }
  },

  mixins: [feeds],

  created () {
    this.feed.active = true
    this.initFeedTemplates()
    if (this.feed.type !== null) this.selectedFeedType = this.feed.type
  },

  methods: {
    onFeedTypeSelect (value) {
      this.feed.type = value
      this.feed.feedType = value.name
      this.feed.config = { filterRules: [], formatRules: [], mappingRules: [], taggingRules: [] }
    }
  },

  computed: {
    isFeedTypeSelected () {
      if ((this.selectedFeedType !== null) && (this.selectedFeedType !== undefined)) return true
      else return false
    }
  },

  components: { ArrowLeftCircleIcon, ArrowRightCircleIcon, ContactModal, Multiselect, ValidationObserver, ValidationProvider }
}
</script>
